export default "__VITE_ASSET__BtOry9V$__"